<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      size="small"
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      resizable
      border
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>

      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="handleCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                icon="el-icon-view"
                :command="{
                  pageType: 'detail',
                  amzFtyCheckCode: row.amzFtyCheckCode,
                }"
              >
                {{ $l('INDEX.btn_view_details') || '查看详情' }}
              </el-dropdown-item>
              <el-dropdown-item
                icon="el-icon-edit"
                divided
                :command="{
                  pageType: 'edit',
                  amzFtyCheckCode: row.amzFtyCheckCode,
                }"
                :disabled="!allow('M') || disabled"
              >
                {{ $l('btn_Edit_Document') || '编辑单据' }}
              </el-dropdown-item>

              <el-dropdown-item
                icon="el-icon-delete"
                :command="{
                  pageType: 'del',
                  amzFtyCheckCode: row.amzFtyCheckCode,
                }"
                :disabled="!allow('D') || disabled"
              >
                {{ $l('btn_Del_Document') || '删除单据' }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>

    <UpdateFtyCheck
      v-if="openEditParam.visible"
      :visible.sync="openEditParam.visible"
      :disabled="openEditParam.checkDisabled"
      :amzFtyCheckCode="openEditParam.amzFtyCheckCode"
      :amzFtyCheckTaskCode="openEditParam.amzFtyCheckTaskCode"
      @reload="() => $emit('reload')"
    />
  </div>
</template>
<script>
import tableColumns from './table-columns'
import UpdateFtyCheck from '../update-fty-check'
export default {
  mixins: [],
  components: { UpdateFtyCheck },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
    amzFtyCheckTaskCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      openEditParam: {
        visible: false,
        checkDisabled: false,
        amzFtyCheckCode: '',
      },
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    handleCommand(command) {
      const { pageType, amzFtyCheckCode } = command
      switch (pageType) {
        case 'detail':
        case 'edit':
          this.openEditParam.visible = true
          this.openEditParam.checkDisabled = pageType === 'detail'
          this.openEditParam.amzFtyCheckCode = amzFtyCheckCode
          this.openEditParam.amzFtyCheckTaskCode = this.amzFtyCheckTaskCode
          break
        case 'del':
          this.del({ amzFtyCheckCode })
          break
        default:
          return
      }
    },
    del(amzFtyCheckCode) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api.ecomAmzFtyCheckDelApi(amzFtyCheckCode).then(() => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
            type: 'success',
          })
          this.$emit('reload')
        })
      })
    },
  },
}
</script>
